import React from "react";
import styles from "../components/laymanComp_css/LaymanPage3.module.css";
import { Link } from "@mui/material";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/orphicEgg.json";


export default function LaymanPage3() {
  return (
    <>
      <Common_html BlockData={BlockData} />
    </>
  );
}
